import { SolveModeSelector } from '@/components/inputs/SolveModeSelector.tsx'
import { ChemistrySelector } from '@/components/inputs/ChemistrySelector.tsx'
import { CapacityInput } from '@/components/inputs/CapacityInput.tsx'
import { VoltageInput } from '@/components/inputs/VoltageInput.tsx'
import { LoadInput } from '@/components/inputs/LoadInput.tsx'
import { EfficiencyInput } from '@/components/inputs/EfficiencyInput.tsx'
import { DoDInput } from '@/components/inputs/DoDInput.tsx'
import { SoCInput } from '@/components/inputs/SoCInput.tsx'
import { SoHInput } from '@/components/inputs/SoHInput.tsx'
import { TemperatureInput } from '@/components/inputs/TemperatureInput.tsx'
import { StorageDaysInput } from '@/components/inputs/StorageDaysInput.tsx'
import { ProfileControls } from '@/components/inputs/ProfileControls.tsx'
import { CollapsibleSection } from '@/components/shared/CollapsibleSection.tsx'
import CutoffVoltageInput from '@/components/chemistry/CutoffVoltageInput.tsx'
import PeukertInfo from '@/components/chemistry/PeukertInfo.tsx'
import BoundaryWarnings from '@/components/chemistry/BoundaryWarnings.tsx'
import { useAppStore } from '@/store/useAppStore.ts'
import { useEffect, useRef } from 'react'

const CHEM_COLORS: Record<string, string> = {
  lifepo4: 'var(--color-chem-lifepo4)',
  liion: 'var(--color-chem-liion)',
  leadacid: 'var(--color-chem-leadacid)',
  nimh: 'var(--color-chem-nimh)',
  alkaline: 'var(--color-chem-alkaline)',
}

export function InputPanel() {
  const showAdvancedMode = useAppStore((s) => s.showAdvancedMode)
  const chemistry = useAppStore((s) => s.battery.chemistry)
  const accentColor = CHEM_COLORS[chemistry] ?? 'var(--color-accent)'
  const panelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleFocusRequest = () => {
      const firstField = panelRef.current?.querySelector<HTMLInputElement>('.numeric-input__field')
      firstField?.focus()
    }
    window.addEventListener('brt:focus-input', handleFocusRequest)
    return () => window.removeEventListener('brt:focus-input', handleFocusRequest)
  }, [])

  return (
    <div ref={panelRef} className="input-panel" style={{ borderColor: accentColor, borderLeftWidth: '3px' }}>
      <h2 className="input-panel__heading">Configuration</h2>
      <SolveModeSelector />
      <ChemistrySelector />
      <CapacityInput />
      <VoltageInput />
      <LoadInput />

      <CollapsibleSection title="Chemistry & Physics" defaultOpen>
        <TemperatureInput />
        <DoDInput />
        <SoCInput />
        <PeukertInfo />
        {showAdvancedMode && (
          <>
            <SoHInput />
            <CutoffVoltageInput />
            <StorageDaysInput />
          </>
        )}
      </CollapsibleSection>

      <CollapsibleSection title="System" defaultOpen={false}>
        <EfficiencyInput />
      </CollapsibleSection>

      <BoundaryWarnings />
      <ProfileControls />
    </div>
  )
}
